import { Row, Col, Card, message, Form, Input, Switch, Button, Typography, Divider } from 'antd';
import { useState, useEffect } from 'react';
import axios from "axios";
import ClassifyStructure from "../../classify/Main"
import InformationModal from '../../classify/components/InformationModal';
const { Title } = Typography;
const Portal = () => {

    const [permissionData, setPermissionData] = useState([]);
    const [permissionProcessData, setPermissionProcessData] = useState([]);
    const [permissionId, setPermissionId] = useState();
    // const [permissionName, setPermissionName] = useState([]);
    const [checkStrictly, setCheckStrictly] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({
        edit: true,
        prefix: "permission",
        languageKey: "permission_language_data",
        node: [],
        data: {
            name: "",
            pathCheck: false,
            path: ""
        }
    });


    const cancelModal = () => {
        setCheckStrictly(false)
        setModalData({
            edit: true,
            prefix: "permission",
            languageKey: "permission_language_data",
            node: [],
            data: {
                name: "",
                pathCheck: false
            }
        })
    }

    const addModal = (prefix, languageKey, node) => {
        console.log(node)
        setModalData((prev) => {
            return {
                ...prev,
                edit: false,
                // prefix: prefix,
                // languageKey: languageKey,
                node: node,
                data: {
                    name: "",
                    pathCheck: false
                }
            }
        })
        setModalShow(true)
    }
    const createPermissionNode = (values, selectedNode) => {
        // console.log(values)
        let url = `/dynamicWebsite/frontend/permission`;
        let classify_structure_type_id = 0;
        let hasParent = 0;

        if (selectedNode?.classify_structure_type_id) {
            classify_structure_type_id = selectedNode?.classify_structure_type_id
            hasParent = 1;
        } //有沒有selected
        let data = {
            "classify_structure_id": 5,
            "classify_structure_type_id": classify_structure_type_id,
            "name": values.name,
            "path_check": 1,
            "permission_language_data": [
                {
                    "language_culture_code": "zh-tw",
                    "language_culture_value": values.name
                },
                {
                    "language_culture_code": "en",
                    "language_culture_value": values.nameEn
                }
            ]
        }
        if (values.pathCheck) {
            data = {
                ...data,
                "path_check": 0,
                "path": values.path,
            }
        }

        createNode("permission", values, selectedNode, url, data, hasParent)
    }
    const createNode = (type, values, selectedNode, url, data, hasParent) => {
        // console.log("selectedNode", selectedNode)

        if (hasParent) { //有沒有selected

            axios.post(url, data)
                .then(response => {
                    if (response.data.status === "success") {
                        message.success('新增成功');
                        setPermissionProcessData([1, "create", selectedNode.classify_structure_type_id, values.name, 9, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], [], { ...values, ...data, ...response.data }])
                        console.log(JSON.parse(JSON.stringify({ ...values, ...data, ...response.data })))
                    }
                    else {
                        message.error(`新增失敗，${response.data.message}`);
                    }
                })
                .catch((error) => {
                })
                .finally(() => {
                    setCheckStrictly(false)
                    setModalData((prev) => {
                        return {
                            ...prev,
                            edit: true,
                            // prefix: "permission",
                            // languageKey: "permission_language_data",
                            node: [],
                            data: {
                                name: "",
                                pathCheck: false,
                                path: ""

                            }
                        }
                    })
                })
        } else {
            axios.post(url, data)
                .then(response => {
                    if (response.data.status === "success") {
                        message.success('新增成功');
                        setPermissionProcessData([2, values.name, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], 0, [Date.now()], [], { ...values, ...data, ...response.data }])
                    }
                    else {
                        message.error(`新增失敗，${response.data.message}`);
                    }
                })
                .catch((error) => {
                })
                .finally(() => {
                    setCheckStrictly(false)
                    setModalData({
                        edit: true,
                        prefix: "permission",
                        languageKey: "permission_language_data",
                        node: [],
                        data: {
                            name: "",
                            pathCheck: false,
                            path: ""

                        }
                    })
                })
        };
    }

    const editModal = (prefix, languageKey, node) => {
        let name = `${node[`${languageKey}`]?.[0]?.language_culture_value !== undefined
            ? node[`${languageKey}`]?.[0]?.language_culture_value
            : node.name}`
        let nameEn = `${node[`${languageKey}`]?.[1]?.language_culture_value !== undefined
            ? node[`${languageKey}`]?.[1]?.language_culture_value
            : node.name}`
        let data = {
            name: name,
            nameEn: nameEn,
            pathCheck: checkStrictly,
        }

        // if (true) {
        if (node.path_check === 0) {
            setCheckStrictly(true)
            data = {
                name: name,
                nameEn: nameEn,
                pathCheck: true,
                path: node.path
            }
        }
        setModalData({
            edit: true,
            prefix: prefix,
            languageKey: languageKey,
            node: node,
            data: data
        })
        setModalShow(true)
    }
    const editPermissionNode = (node, newData) => {
        console.log(newData)
        console.log(node)
        let url = `/dynamicWebsite/frontend/permission`;

        let data = [{
            "permission_id": node.permission_id,
            "classify_structure_id": 5,
            "classify_structure_type_id": node.classify_structure_type_parent_id,
            "name": newData.name,
            "permission_language_data": [
                {
                    "language_culture_code": "zh-tw",
                    "language_culture_value": newData.name
                },
                {
                    "language_culture_code": "en",
                    "language_culture_value": newData.nameEn
                }
            ],
            // "path_check": newData.path_check,
        }]
        if (!newData.path_check) {
            data =
            {
                ...data[0],
                "path_check": 1,
            }

        }
        else {
            data =
            {
                ...data[0],
                "path_check": 0,
            }

        }
        editNode("permission", url, data, node.classify_structure_type_id, newData.name)
    }
    const editNode = (type, url, data, classify_structure_type_id, newName) => {
        axios.patch(url, data)
            .then(response => {
                // console.log(response.data.status)
                if (response.data.status === "success") {
                    message.success('修改成功');
                    setPermissionProcessData([3, "edit", classify_structure_type_id, newName, null, null, null, data])
                }
                else {
                    message.error(`修改失敗，${response.data.message}`);
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setCheckStrictly(false)
                setModalData({
                    edit: true,
                    prefix: "permission",
                    languageKey: "permission_language_data",
                    node: [],
                    data: {
                        name: "",
                        pathCheck: false,
                        path: ""

                    }
                })
            })

    };
    const deletePermissionNode = (node, classify_structure_type_id) => {
        let url = `/dynamicWebsite/frontend/permission`;
        let data = [{
            "permission_id": node.permission_id,
            "classify_structure_id": 5,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("permission", url, data, classify_structure_type_id)
    }
    const deleteNode = (type, url, data, classify_structure_type_id) => {
        axios
            .delete(url, { data: data })
            .then(response => {
                // console.log(response.data.status)
                if (response.data.status === "success") {
                    message.success('刪除成功');
                    setPermissionProcessData([4, "delete", classify_structure_type_id])
                    if (data?.[0]?.permission_id === permissionId) {
                        setPermissionId(null)
                    }
                }
                else {
                    message.error('刪除失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {

            })
    };
    const formItemsRender = () => {
        return (
            <>
                <Form.Item
                    label={"英文名稱"}
                    name="nameEn"
                >
                    {/* {console.log(checkStrictly)} */}
                    <Input />
                </Form.Item>
                <Form.Item
                    label={"連結"}
                    name="pathCheck"
                >
                    {/* {console.log(checkStrictly)} */}
                    <Switch
                        checkedChildren="外部連結"
                        unCheckedChildren="內部連結"
                        checked={checkStrictly}
                        onChange={setCheckStrictly}
                    />
                </Form.Item>
                {checkStrictly && <>
                    <Form.Item
                        label={"連結"}
                        name="path"
                        rules={[
                            {
                                required: true,
                                message: `此為必填項目`
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={"另開分頁"}
                        name="blank"
                    >
                        <Switch
                            checkedChildren="是"
                            unCheckedChildren="否"
                        />
                    </Form.Item>
                </>}
                <Form.Item
                    label={"狀態"}
                    name="pathCheck"
                >
                    {/* {console.log(checkStrictly)} */}
                    <Switch
                        checkedChildren="啟用"
                        unCheckedChildren="停用"
                    />
                </Form.Item>
            </>
        )
    }

    const getPermissionId = (node) => {

        if (node) {
            setPermissionId(node?.permission_id)
            // let name = node?.permission_language_data[0].language_culture_value
            // setPermissionName(name !== undefined ? name : node?.name)
        }
        else {
            setPermissionId(null)
        }
    }

    useEffect(() => {
        axios.get('/dynamicWebsite/frontend/permission', {
            params: {
                classify_structure_id: 5,
                classify_structure_type_id: 0
            }
        })
            .then(response => {
                setPermissionData(response.data['data'])
            })
            .catch((error) => {
            })
            .finally(() => {
            })
        // }

    }, [])


    return (
        <Row gutter={[10, 20]} justify="space-around" style={{ padding: "10px" }}>
            <InformationModal
                title={"資訊填寫"}
                edit={modalData.edit}
                value={modalData.data}
                treeNode={modalData.node}
                modalShow={modalShow}
                onSubmit={createPermissionNode}
                onChange={editPermissionNode}
                setModalShow={setModalShow}
                cancelModal={cancelModal}
                formItemsRender={formItemsRender}
            ></InformationModal>
            <Col span={24}>
                <Card
                // title="網站名稱"
                >
                    <Row gutter={[8, 8]} align={'middle'}>
                        <Col span={10}>
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col span={8}>
                                    <Title level={4}>網站名稱</Title>
                                </Col>
                                <Col span={8}>
                                    <Button type="primary"
                                        style={{
                                            backgroundColor: '#AEBDCA'
                                        }}
                                        size={"small"}

                                        onClick={{}}
                                    >
                                        選單管理
                                    </Button>
                                </Col>
                                <Col span={8}>
                                    <Button type="primary"
                                        style={{
                                            backgroundColor: '#AEBDCA'
                                        }}
                                        size={"small"}

                                        onClick={{}}
                                    >
                                        文章管理
                                    </Button>
                                </Col>
                            </Row>
                            <Divider />
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col span={24}>
                                    <Card>
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            <Col span={24}>
                                                <Title level={4}>選單統計</Title>
                                            </Col>
                                            <Divider />


                                        </Row>

                                    </Card>
                                </Col>

                            </Row>
                            <Divider />
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col span={24}>
                                    <Card>
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            <Col span={24}>
                                                <Title level={4}>文章統計</Title>
                                            </Col>
                                            <Divider />


                                        </Row>

                                    </Card>
                                </Col>

                            </Row>

                        </Col>
                        <Col span={14}>
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col span={24}>
                                    <Card>
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            <Col span={24}>
                                                <Title level={4}>網站每日瀏覽人數</Title>
                                            </Col>
                                            <Divider />


                                        </Row>

                                    </Card>
                                </Col>

                            </Row>
                            <Divider />
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col span={24}>
                                    <Card>
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            <Col span={24}>
                                                <Title level={4}>文章點擊數</Title>
                                            </Col>
                                            <Divider />


                                        </Row>

                                    </Card>
                                </Col>

                            </Row>
                        </Col>

                    </Row>


                </Card>

            </Col>
        </Row>
    )
}
export default Portal;